import { lotEventFromFirestore } from '@parallel-fluidics/shared/models/lots';
import {
  collection,
  getFirestore,
  orderBy,
  query,
} from 'firebase/firestore';
import useRealtimeDocs from 'hooks/use-realtimeDocs';
import { useMemo } from 'react';

/**
 * Realtime Activity log for a lot (lots/{id}/events, newest first) —
 * realtime so the table reflects consumption happening at other
 * stations while the detail page is open.
 */
export default function useRealtimeLotEvents(lotId) {
  const eventsQuery = useMemo(() => {
    if (!lotId) return null;
    return query(
      collection(getFirestore(), 'lots', lotId, 'events'),
      orderBy('_createdBy.timestamp', 'desc'),
    );
  }, [lotId]);

  return useRealtimeDocs({
    query: eventsQuery,
    transformData: lotEventFromFirestore,
  });
}
